const NAME = 'HEAP';
const CNameMapping = {
  [NAME]: NAME,
  Heap: NAME,
  heap: NAME,
  'Heap.io': NAME,
};

export { NAME, CNameMapping };
